module.exports = __webpack_public_path__ + "img/telluride-21.2133dcf0.png";